const LoginEvents = function () {
    const PARAM_NAME_LOGIN_CONFLICT = 'login-conflict';
    const PARAM_NAME_LOGIN_SUCCESS = 'login-success';
    const PARAM_NAME_PASSWORD_CHANGED = 'password-changed-successfully';
    const PARAM_VALUE_SIGNIN = 1;
    const PARAM_VALUE_SIGNUP = 2;

    function _lookup() {
        let currentUrl = document.URL;
        if (currentUrl.indexOf(PARAM_NAME_LOGIN_CONFLICT) !== -1) {
            let conflictParamFound = (new URL(currentUrl)).searchParams.get(PARAM_NAME_LOGIN_CONFLICT);
            if (conflictParamFound !== null) {
                $.ajax({
                    url: vitrineUrl + '/login/conflict',
                    method: 'GET',
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        getLoginError(data);
                    },
                    error: function (jqXHR) {
                        TINK.redirectIfConflict(jqXHR);
                    }
                });

                let cleanedUrl = TINK.removeParamFromUrl(PARAM_NAME_LOGIN_CONFLICT, window.location.href);
                if (cleanedUrl !== currentUrl) {
                    window.history.pushState({}, '', cleanedUrl);
                }
            }
        }

        signInLookup(currentUrl);
        passwordChangedLookup(currentUrl);
    }

    function passwordChangedLookup(currentUrl) {
        const passwordChangedConfirmation = {
            href: '#passwordChangedConfirmation',
            maxWidth: '700',
            width: 'auto',
            height: 'auto'
        };

        if (currentUrl.indexOf(PARAM_NAME_PASSWORD_CHANGED) !== -1) {
            TINK.showPopUp(passwordChangedConfirmation).then(function () {
                let passwordChangedConfirmation = $('#passwordChangedConfirmation');
                passwordChangedConfirmation.find('.focusable').focus();
                $('.fancybox-skin, .fancybox-inner').css('background-color', 'transparent');
            });

            let url = TINK.removeParamFromUrl(PARAM_NAME_PASSWORD_CHANGED, currentUrl);
            if (url !== currentUrl) {
                window.history.pushState({}, '', url);
            }
        }
    }

    function loginSuccessAjax(successValue) {
        $.ajax({
            url: vitrineUrl + '/login/success',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                sendGa4Information(successValue, data);
            },
            error: function (jqXHR) {
                TINK.redirectIfConflict(jqXHR);
            }
        });
    }

    function signInLookup(currentUrl) {
        var RememberMeSuccessCookie = TINK.getCookie('remember-me-success');

        if (currentUrl.indexOf(PARAM_NAME_LOGIN_SUCCESS) !== -1) {
            let loginSuccessParamFound = (new URL(currentUrl)).searchParams.get(PARAM_NAME_LOGIN_SUCCESS);
            if (loginSuccessParamFound !== null && (loginSuccessParamFound == PARAM_VALUE_SIGNIN || loginSuccessParamFound == PARAM_VALUE_SIGNUP)) {
                let queryString = window.location.search;
                let urlParams = new URLSearchParams(queryString);
                let successValue = urlParams.get(PARAM_NAME_LOGIN_SUCCESS);
                loginSuccessAjax(successValue);

                let cleanedUrl = TINK.removeParamFromUrl(PARAM_NAME_LOGIN_SUCCESS, window.location.href);
                if (cleanedUrl.endsWith("?")) {
                    cleanedUrl = cleanedUrl.substring(0, cleanedUrl.length - 1);
                }
                if (cleanedUrl !== currentUrl) {
                    window.history.pushState({}, '', cleanedUrl);
                }
            }
        } else if (RememberMeSuccessCookie != undefined) {
            TINK.deleteCookie('remember-me-success');
            loginSuccessAjax(1);
        }
    }

    function sendGa4Information(eventName, ga4LoginInformation) {
        pushDataLayerSignUpSignInValidate(eventName == PARAM_VALUE_SIGNIN ? "login" : "sign_up",
            ga4LoginInformation.userEcomSegment,
            ga4LoginInformation.userFidelitySegment,
            ga4LoginInformation.userLoyaltyProgram,
            ga4LoginInformation.isBannerBuyer,
            ga4LoginInformation.userId,
            ga4LoginInformation.bannerCode);
    }

    function getLoginError(jsonResponseValue) {
        let url = '/' + lang + '/showLoginForm';

        $.ajax({
            url: url,
            type: 'GET',
            async: false
        }).always(function (data, status, jqXHR) {
            let $data = $(data);
            $data.each(function () {
                let $item = $(this);
                if ($item.is('#fancybox-sign-in-box-conflict')) {
                    $('#modal-sign-in-box-conflict-container').append($item.children());
                }
            });

            _handleLoginError(jsonResponseValue);
        });
    }

    function _handleLoginError(jsonResponseValue) {
        let errorCode = jsonResponseValue.errorCode;
        let removeInProgress = true;

        switch (errorCode) {
            case 'disabled-account':
                disabledAccount();
                break;
            case 'locked-account':
                lockedAccount();
                break;
            case 'scenario-2':
                loginScenario2Validation(jsonResponseValue);
                break;
            case 'cp-pw-account':
                showModalLoginConflicts('.cpPw');
                break;
            case 'none-intrusive-conflict':
                submitLoginAfterConflict();
                removeInProgress = false;
                break;
            default:
                displayErrorLoginMessage(genericErrorMessage);
        }

        if (removeInProgress) {
            $('#sign-in-box').removeClass('in-progress');
        }
    }

    function submitLoginAfterConflict() {
        window.location.href = aadB2cLoginUrl;
    }

    function loginScenario2Validation(json) {
        // Setup dialog
        $('#registeredCartNumberOfItems').text(json.registeredCartQuantity);
        $('#anonymousCartNumberOfItems').text(json.anonymousCartQuantity);

        $('#confirmScenario2').click(function () {
            var data = {
                scenario: 'CART',
                accountType: $('input[type=radio][name=cartSelected2]:checked').val()
            };

            sendAjaxRequestForValidation(data).then(function () {
                submitLoginAfterConflict();
            });
        });

        showModalLoginConflicts('#scenario--2');
    }

    function showModalLoginConflicts(modalCurrent) {
        $(modalCurrent).addClass('is_active').dishide();
        injectSVG();
    }

    return {
        lookup: _lookup,
        handleLoginError: _handleLoginError
    }
}();